export default __webpack_public_path__ + "static/media/vr.805daeb0.svg";